import React from "react";

import { Container } from "./styles";

export type Props = {
  message: string;
};

export const PianoTooltipDisplay: React.FunctionComponent<Props> = ({ message }) => (
  <Container
    dangerouslySetInnerHTML={{
      __html: message,
    }}
  />
);

PianoTooltipDisplay.displayName = "PianoTooltipDisplay";
